import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    badge: {
      '& .MuiBadge-badge': {
        right: '2px',
        top: '13px',
        padding: theme.spacing(0, 0.5),
      },
    },
    avatar: {
      marginLeft: '5px',
    },
    listItemRoot: {
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5),
      textTransform: 'initial',
      width: '100%',
    },
    listItemTextMultiline: {
      '&.MuiListItemText-multiline': {
        marginTop: 0,
        marginBottom: 0,
      },
    },
    listItemTextPrimary: {
      fontSize: theme.typography.body2.fontSize,
    },
    listItemTextSecondary: {
      fontSize: theme.typography.caption.fontSize,
      color: theme.palette.text.secondary,
    },
    listItemTextSecondaryOldUi: {
      fontSize: '0.875rem',
      color: '#111',
    },
  };
};
